import {
  SubmissionStatus,
  useUpsertSubmissionMutation,
} from '@converge/graphql';

import { NewConvergeButton } from '../../../presentation';
import { useUnderwritingSubmissionStateContext } from '../underwriting.submission.context';

export const UnderwritingUnbindSubmission = () => {
  const { upsertSubmission, loading } = useUpsertSubmissionMutation();
  const {
    submission,
    info: { isMissingBoundQuote },
  } = useUnderwritingSubmissionStateContext();

  if (!isMissingBoundQuote) {
    return null;
  }

  return (
    <NewConvergeButton
      label={'Unbind submission'}
      disabled={!isMissingBoundQuote}
      loading={loading}
      onClick={async () => {
        await upsertSubmission({
          variables: {
            details: {
              uuid: submission.uuid,
              status: SubmissionStatus.Quoted,
              subStatus: null,
            },
          },
        });
      }}
    />
  );
};
